<script lang="ts">
  import { Label } from '$lib/components/ui/label';
  import * as Select from '$lib/components/ui/select/index.js';
  import { gumTypes, type GumType } from '@briefmarken_katalog/types';
  import { t, type TranslationKey } from '$lib/i18n';

  const UNSET = '__unset__';

  let {
    value = $bindable<GumType | undefined>(undefined),
    isReadonly = false,
    containerClass = "grid grid-cols-4 items-center gap-4",
    selectClass = "col-span-3",
  }: {
    value: GumType | undefined;
    isReadonly?: boolean;
    containerClass?: string;
    selectClass?: string;
  } = $props();

  let internalValue = $state<string>(value ?? UNSET);

  $effect(() => {
    internalValue = value ?? UNSET;
  });

  $effect(() => {
    value = internalValue === UNSET ? undefined : internalValue as GumType;
  });

  const labelKey = (v: string): TranslationKey =>
    (v === UNSET ? 'fields.gum.unset' : `fields.gum.${v}`) as TranslationKey;
</script>

<div class={containerClass}>
  <Label class="text-right">{$t('fields.gum.label')}</Label>
  {#if isReadonly}
    <div class="{selectClass} p-2 border rounded">{$t(labelKey(internalValue))}</div>
  {:else}
    <Select.Root type="single" name="with_gum" bind:value={internalValue}>
      <Select.Trigger class={selectClass}>
        {$t(labelKey(internalValue))}
      </Select.Trigger>
      <Select.Content>
        <Select.Group>
          <Select.Item value={UNSET} label={$t('fields.gum.unset')}>
            {$t('fields.gum.unset')}
          </Select.Item>
          {#each gumTypes as g}
            <Select.Item value={g} label={$t(labelKey(g))}>
              {$t(labelKey(g))}
            </Select.Item>
          {/each}
        </Select.Group>
      </Select.Content>
    </Select.Root>
  {/if}
</div>
